export default __webpack_public_path__ + "static/media/panel2.9f6976c3.jpg";